<div class="layout-wrapper">
  <laas-header [hidden]="authenticationService.isEmbedded"></laas-header>
  <div class="layout-main">
    <laas-side-menu></laas-side-menu>
    <div class="layout-content" [class.menu-hide]="authenticationService.isEmbedded || !(menuDataService.toggleMenuBar | async)" [class.header-hide]="authenticationService.isEmbedded">
      <router-outlet></router-outlet>
    </div>
  </div>
  <laas-footer></laas-footer>
</div>
